import { render, staticRenderFns } from "./PlotDataSourceSpecimenaSummary.vue?vue&type=template&id=0d492689"
import script from "./PlotDataSourceSpecimenaSummary.vue?vue&type=script&lang=js"
export * from "./PlotDataSourceSpecimenaSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports